import _ from "lodash";
import numeral from "numeral";
import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import {
  calDebtCreditCard,
  calTotalCreditorFloatInterest,
  cn,
  generateAmortizationSchedule,
  toFloat2
} from "../../../utils/useFunctions";
import { OPTIONS_TYPE_CAR, OPTIONS_TYPE_PLACE } from "../../balance/functions";
import {
  formatPeriodTime
} from "../../debt/component/VIDebtTable";
import { PdfCard, PdfCardGray, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_13
} from "../styles/pdf.style";

function PdfPageDebtTwo({ page, debtShortItems=[] }) {
  const balanceData = useBalanceStore((state) => state.balanceData);



  const debtLongItems = useMemo(() => {
    const newDebtLongItems = [];

    if (balanceData?.debt_long_list?.length > 0) {
      for (const debt_long_item of balanceData?.debt_long_list?.filter((item) => item !== null && item !== undefined)) {
        const keys = Object.keys(debt_long_item);
        for (const key of keys) {
          if (_.isArray(debt_long_item[key])) {
            for (const item of debt_long_item[key]) {
              let createItem = {
                unpaid_amount: item?.unpaid_amount,
                pay_permonth: item?.pay_permonth,
                interest: item?.interest,
                period: item?.period,
                period_time: formatPeriodTime(item?.period),
                type_payment: "",
                label: item?.title,
              };

              // รถยนต์
              if (debt_long_item?.options_debt_long === "debt_car") {
                const findTypeCar = OPTIONS_TYPE_CAR?.filter((thisType) => {
                  if (thisType.value === item?.type_car) return thisType;
                });
                if (findTypeCar) {
                  createItem.label = `${findTypeCar[0]?.label} ${item?.title_car}`;
                }
              }

              // สินเชื่อที่อยู่อาศัย
              if (debt_long_item?.options_debt_long === "debt_place") {
                const findTypePlace = OPTIONS_TYPE_PLACE?.filter((thisType) => {
                  if (thisType.value === item?.type_place) return thisType;
                });
                const typePlace = item?.type_place_other
                  ? item?.type_place_other
                  : findTypePlace?.[0]?.label;
                if (typePlace) {
                  createItem.label = `${typePlace} (${item?.address_place})`;
                }
              }

              newDebtLongItems.push(createItem);
            }
          }
        }
      }
    }
    return newDebtLongItems;
  }, [balanceData]);

  const mergeDebtItems = useMemo(() => {
    const newMergeDebtItems = [
      {
        label: "หนี้ระยะสั้น",
        items: debtShortItems,
      },
      // {
      //   label: "หนี้ระยะยาว",
      //   items: debtLongItems,
      // },
    ];
    return newMergeDebtItems;
  }, [balanceData]);

  const totalItem = useMemo(() => {
    let total = 0;
    for (const item of [...debtShortItems, ...debtLongItems]) {
      total += item?.unpaid_amount;
    }
    return total;
  }, [balanceData]);

  const totalShortItem = useMemo(() => {
    let total = 0;
    for (const item of debtShortItems) {
      total += item?.unpaid_amount;
    }
    return total;
  }, [balanceData]);

  const sumTotalWeightInterest = () => {
    let total_unpaid = 0;
    let total_left = 0;
    let total_final = 0;

    if (!balanceData?.debt_short_list) return total_final;

    for (const debt_short_item of balanceData?.debt_short_list) {
      const keys = Object.keys(debt_short_item);
      for (const key of keys) {
        if (_.isArray(debt_short_item[key])) {
          for (const item of debt_short_item[key]) {
            if (
              debt_short_item?.options_debt_short === "debt_informal_shortterm"
            ) {
              total_unpaid += item?.start_amount;
              total_left += item?.start_amount * item?.interest;
            } else if (
              debt_short_item?.options_debt_short === "debt_creditcard" &&
              item?.type_payment === "pay_full"
            ) {
              const creditor = calDebtCreditCard(item);
              total_unpaid += item?.unpaid_amount;
              total_left += item?.unpaid_amount * 0;
            } else if (
              debt_short_item?.options_debt_short === "debt_shortterm_other"
            ) {
              total_unpaid += item?.unpaid_amount;
              total_left += item?.unpaid_amount * item?.interest * 12;
            } else {
              total_unpaid += item?.unpaid_amount;
              total_left += item?.unpaid_amount * item?.interest;
            }
          }
        }
      }
    }
    total_final = total_left / total_unpaid;
    return total_final;
  };


  const sumTotalInterest = () => {
    let total_unpaid = 0;
    let total_left = 0;

    if (!balanceData?.debt_short_list) return total_left;

    for (const debt_short_item of balanceData?.debt_short_list) {
      const keys = Object.keys(debt_short_item);
      for (const key of keys) {
        if (_.isArray(debt_short_item[key])) {
          for (const item of debt_short_item[key]) {
            if (debt_short_item?.options_debt_short === "debt_shortterm") {
              const interest_min = toFloat2(
                (item.unpaid_amount * item.interest) / 100
              );

              const loanDetails = generateAmortizationSchedule(
                item.unpaid_amount,
                item.interest,
                item.pay_permonth
              );

              const totalInterest = loanDetails?.reduce((acc, item) => {
                return acc + item?.interestPayment;
              }, 0);
              total_left += totalInterest;
            }

            if (
              debt_short_item?.options_debt_short === "debt_informal_shortterm"
            ) {
              total_unpaid += item.start_amount;
              total_left += item.start_amount * (item.interest / 100);
            } else if (
              debt_short_item?.options_debt_short === "debt_creditcard"
            ) {
              const creditor = calDebtCreditCard(item);
              total_unpaid += item.unpaid_amount;
              total_left +=
                item?.type_payment === "pay_full"
                  ? 0
                  : creditor?.total_creditor_interest;
            } else if (
              debt_short_item?.options_debt_short === "debt_shortterm_other"
            ) {
              const creditor = calTotalCreditorFloatInterest(item);
              const totalCreditorInterest = creditor?.reduce(
                (acc, item, index) => {
                  if (index > 11) {
                    return acc;
                  }
                  return acc + item.interest;
                },
                0
              );
              total_unpaid += item.unpaid_amount;
              total_left += totalCreditorInterest;
            } else {
              total_unpaid += item.unpaid_amount;
              // total_left += item.unpaid_amount * (item.interest / 100);
            }
          }
        }
      }
    }
    return total_left;
  };


  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      {/* <PdfHeaderText title="แผนจัดการหนี้สิน " icon="/images/wealth_1.svg" /> */}

      {/* แผนจัดการหนี้สิน SECOND */}
      <PdfCard>
        <PdfCardWhite className={cn("px-3")}>
          <div className={cn(STYLE_PDF_TEXT_MEDIUM_12)}>
            1. รวมหนี้ระยะสั้นเป็นก้อนเดียวกัน 
          </div>
          <div
            className={cn(
              "flex justify-between mt-1",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div>จำนวนเงินค้างชำระ</div>
            <div>{numeral(totalShortItem).format("0,0")} บาท</div>
          </div>
          <PdfLine />
          <div className="space-x-2 grid grid-cols-6 items-center">
            <div className="flex space-x-2 items-center col-span-2">
              <div>
                <img src="/images/emoji_bar_chart.svg" width={18} height={18} />
              </div>
              <div className={cn(STYLE_PDF_TEXT_MEDIUM_12)}>
                สินทรัพย์ไม่มีหลักประกัน
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-right col-span-2")}
            >
              จำนวนเงินค้างชำระ
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-right ")}>
              ดอกเบี้ย(%)
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "text-right ")}>
              ดอกเบี้ย(บาท)
            </div>
          </div>

          <PdfCardGray className={cn("mt-2")}>
            {debtShortItems?.map((item, index) => {
              let interest = item?.interest;

              let customAmountOfInterest = item?.customAmountOfInterest;
              if (item?.options_debt_short === "debt_creditcard") {
                interest =
                  item?.type_payment_ori === "pay_full" ? 0 : item?.interest;
              } else if (item?.options_debt_short === "debt_shortterm_other") {
                interest = item?.interest * 12;
              }
              return (
                <div
                  key={index}
                  className={cn("grid grid-cols-6 justify-between")}
                >
                  <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "col-span-2")}>
                    {item?.title} {item?.label}
                  </div>
                  <div
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                      "text-right col-span-2"
                    )}
                  >
                    {numeral(item?.unpaid_amount).format("0,0.00")} บาท
                  </div>
                  <div
                    className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12, "text-right")}
                  >
                    {numeral(interest).format("0,0.00")}%
                  </div>
                  <div
                    className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12, "text-right")}
                  >
                    {numeral(customAmountOfInterest).format("0,0.00")}
                  </div>
                </div>
              );
            })}
          </PdfCardGray>
          <div className="grid grid-cols-6 justify-between mt-2">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_12, "col-span-2")}>
              ยอดรวม
            </div>
            <div
              className={cn(
                STYLE_PDF_TEXT_MEDIUM_BLUE_13,
                "mr-2 col-span-2 text-right"
              )}
            >
              {numeral(totalShortItem).format("0,0.00")} บาท
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13, "mr-2 text-right")}
            >
              {numeral(sumTotalWeightInterest()).format("0,0.00")}%
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13, "mr-2 text-right")}
            >
              {numeral(sumTotalInterest()).format("0,0.00")}
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <div className={"w-full  " + STYLE_PDF_TEXT_MEDIUM_12}>
        *หากมีเงินสดเพียงพอ รีบนำไปชำระหนี้ที่ดอกเบี้ยสูง หรือเลือกปิดหนี้หลายรายการเลย*
      </div>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageDebtTwo;
